import React from 'react';

import { DetailsTooltipStyles } from '~src/spacesPlatform/components/card/DetailsTooltipStyles';

import { EntityLink, EntityLinkProps } from './EntityLink';


export interface RelatedEntityListProps {
  label: string;
  list: EntityLinkProps[];
}

export function RelatedEntityList(props: RelatedEntityListProps) {
  return props.list && props.list.length > 0 && (
    <>
      <dt className={DetailsTooltipStyles.DescriptionTerm}>{props.label}</dt>
      { props.list.map((link, index) =>
        <dd className={DetailsTooltipStyles.DescriptionDetails} key={`related-entity-${index}`}><EntityLink {...link}  /></dd>
      )}
    </>
  );
}
